// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"2e85bae9","43":"a2402db5","501":"6a4320b1","543":"5c326581"}[chunkId] + ".chunk.css";
};